import { API_CALLS } from '@/services/apis/index.js';
export default {
  logIn(context, data) {
    return new Promise((resolve, reject) => {
     API_CALLS.logInAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getUsers() {
    return new Promise((resolve, reject) => {
     API_CALLS.getUsersAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPermissions() {
    return new Promise((resolve, reject) => {
     API_CALLS.getPermissionsAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteUser(context, id) {
    return new Promise((resolve, reject) => {
     API_CALLS.deleteUserAPI(id)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  editUser(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.editUserAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createUser(context, data) {
    return new Promise((resolve, reject) => {
   API_CALLS.createUserAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  //-------------KPIS--------------------------
  getWarehouseKPI() {
    return new Promise((resolve, reject) => {
     API_CALLS.getWarehouseKPIAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSEKPI() {
    return new Promise((resolve, reject) => {
     API_CALLS.getSEKPI_API()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCustomKPI(context, data) {
    return new Promise((resolve, reject) => {
    API_CALLS.getCustomKPI_API(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getKPI(context, data) {
    return new Promise((resolve, reject) => {
    API_CALLS.getKPI_API(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};
